import React, { FC } from 'react';
import { Icon, IconProps } from '@agria/theme/src/components/icon/Icon';

export const Tick: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m11.2114 21.7346 15.3-15.29994c.5796-.57955 1.5532-.57955 2.1328 0 .5795.57954.5795 1.55313 0 2.13267L11.2114 26l-7.88175-7.8818c-.57955-.5795-.57955-1.5532 0-2.1327.57954-.5796 1.55317-.5796 2.13272 0l5.74903 5.7491Z"
      clipRule="evenodd"
    />
  </Icon>
);
